import script from "./FeaturedPodcast.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedPodcast.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedPodcast.vue?vue&type=style&index=0&id=1506d10f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1506d10f"]])

export default __exports__